import { ACDSessionManager, HttpUtilService, HttpClient } from '@nice-devone/core-sdk';
import { logger } from '../../../utils/logger';

/**
 * Set agent state to Available
 */
export async function setAgentAvailable(): Promise<void> {
  logger.debug('[CXone SDK] Setting agent to Available...');
  await setAgentState('Available');
}

/**
 * Set agent state to Unavailable with reason
 */
export async function setAgentUnavailable(reasonCode?: string): Promise<void> {
  logger.debug('[CXone SDK] Setting agent to Unavailable...', reasonCode);
  await setAgentState('Unavailable', reasonCode);
}

/**
 * Set agent state with optional unavailable reason
 *
 * API: POST /inContactAPI/services/v13.0/agent-sessions/{sessionId}/state?state=unavailable&reason=ReasonName
 */
export async function setAgentState(state: string, reasonCodeOrName?: string): Promise<void> {
  logger.debug('[CXone SDK] Setting agent state:', state, reasonCodeOrName);

  const acdSession = ACDSessionManager.instance;
  const sessionId = acdSession.getSessionId();
  const baseUrl = acdSession.cxOneConfig?.acdApiBaseUri;
  const authToken = acdSession.accessToken;

  if (!sessionId || !baseUrl || !authToken) {
    logger.error('[CXone SDK] Missing session info for setAgentState:', {
      hasSessionId: !!sessionId,
      hasBaseUrl: !!baseUrl,
      hasAuthToken: !!authToken,
    });
    throw new Error('Agent session not initialized');
  }

  const params = new URLSearchParams();
  params.append('state', state.toLowerCase());

  if (reasonCodeOrName && state === 'Unavailable') {
    params.append('reason', reasonCodeOrName);
  }

  const url = `${baseUrl}/inContactAPI/services/v13.0/agent-sessions/${sessionId}/state?${params.toString()}`;

  logger.debug('[CXone SDK] setAgentState request:', {
    url,
    state,
    reasonCodeOrName,
  });

  try {
    const utilService = new HttpUtilService();
    const reqInit = utilService.initHeader(authToken, 'application/json');
    const response = await HttpClient.post(url, reqInit);
    logger.debug('[CXone SDK] setAgentState success:', response);
  } catch (error) {
    logger.error('[CXone SDK] setAgentState failed:', error);
    throw error;
  }
}
